/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Globalsearch_Semantic_Loading1Inputs */

const id_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mencari kecocokan berdasarkan makna...`)
};

const ms_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mencari padanan mengikut makna...`)
};

const da_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finder matcher efter betydning...`)
};

const de_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treffer nach Bedeutung werden gesucht...`)
};

const en_us2_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finding matches by meaning...`)
};

const es_es2_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando coincidencias por significado...`)
};

const es_mx2_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando coincidencias por significado...`)
};

const fil_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naghahanap ng mga tugma ayon sa kahulugan...`)
};

const fr_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche de correspondances par sens...`)
};

const it_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricerca delle corrispondenze per significato...`)
};

const hu_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelentés szerinti találatok keresése...`)
};

const nl_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overeenkomsten op betekenis zoeken...`)
};

const no_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finner treff etter betydning...`)
};

const pl_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyszukiwanie dopasowań według znaczenia...`)
};

const pt_br2_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando correspondências por significado...`)
};

const pt_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A procurar correspondências por significado...`)
};

const ro_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se caută potriviri după sens...`)
};

const fi_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etsitään merkityksen perusteella löytyviä osumia...`)
};

const sv_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Söker efter matchningar efter betydelse...`)
};

const vi_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tìm kết quả khớp theo ý nghĩa...`)
};

const tr_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anlama göre eşleşmeler bulunuyor...`)
};

const cs_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledání shod podle významu...`)
};

const bg_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене на съвпадения по смисъл...`)
};

const ru_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск совпадений по смыслу...`)
};

const uk_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук збігів за значенням...`)
};

const ar_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ العثور على المطابقات حسب المعنى...`)
};

const hi_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अर्थ के आधार पर मिलान खोजे जा रहे हैं...`)
};

const th_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังค้นหารายการที่ตรงกันตามความหมาย...`)
};

const ja_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`意味による一致を検索しています...`)
};

const zh_cn2_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在查找按含义匹配的结果...`)
};

const zh_hant1_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在尋找依意義相符的結果...`)
};

const ko_globalsearch_semantic_loading1 = /** @type {(inputs: Globalsearch_Semantic_Loading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`의미별 일치 항목을 찾는 중...`)
};

/**
* | output |
* | --- |
* | "Finding matches by meaning..." |
*
* @param {Globalsearch_Semantic_Loading1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const globalsearch_semantic_loading1 = /** @type {((inputs?: Globalsearch_Semantic_Loading1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Globalsearch_Semantic_Loading1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_globalsearch_semantic_loading1(inputs)
	if (locale === "ms") return ms_globalsearch_semantic_loading1(inputs)
	if (locale === "da") return da_globalsearch_semantic_loading1(inputs)
	if (locale === "de") return de_globalsearch_semantic_loading1(inputs)
	if (locale === "en-US") return en_us2_globalsearch_semantic_loading1(inputs)
	if (locale === "es-ES") return es_es2_globalsearch_semantic_loading1(inputs)
	if (locale === "es-MX") return es_mx2_globalsearch_semantic_loading1(inputs)
	if (locale === "fil") return fil_globalsearch_semantic_loading1(inputs)
	if (locale === "fr") return fr_globalsearch_semantic_loading1(inputs)
	if (locale === "it") return it_globalsearch_semantic_loading1(inputs)
	if (locale === "hu") return hu_globalsearch_semantic_loading1(inputs)
	if (locale === "nl") return nl_globalsearch_semantic_loading1(inputs)
	if (locale === "no") return no_globalsearch_semantic_loading1(inputs)
	if (locale === "pl") return pl_globalsearch_semantic_loading1(inputs)
	if (locale === "pt-BR") return pt_br2_globalsearch_semantic_loading1(inputs)
	if (locale === "pt") return pt_globalsearch_semantic_loading1(inputs)
	if (locale === "ro") return ro_globalsearch_semantic_loading1(inputs)
	if (locale === "fi") return fi_globalsearch_semantic_loading1(inputs)
	if (locale === "sv") return sv_globalsearch_semantic_loading1(inputs)
	if (locale === "vi") return vi_globalsearch_semantic_loading1(inputs)
	if (locale === "tr") return tr_globalsearch_semantic_loading1(inputs)
	if (locale === "cs") return cs_globalsearch_semantic_loading1(inputs)
	if (locale === "bg") return bg_globalsearch_semantic_loading1(inputs)
	if (locale === "ru") return ru_globalsearch_semantic_loading1(inputs)
	if (locale === "uk") return uk_globalsearch_semantic_loading1(inputs)
	if (locale === "ar") return ar_globalsearch_semantic_loading1(inputs)
	if (locale === "hi") return hi_globalsearch_semantic_loading1(inputs)
	if (locale === "th") return th_globalsearch_semantic_loading1(inputs)
	if (locale === "ja") return ja_globalsearch_semantic_loading1(inputs)
	if (locale === "zh-CN") return zh_cn2_globalsearch_semantic_loading1(inputs)
	if (locale === "zh-Hant") return zh_hant1_globalsearch_semantic_loading1(inputs)
	return ko_globalsearch_semantic_loading1(inputs)
});
export { globalsearch_semantic_loading1 as "globalSearch.semantic.loading" }